import { WEATHER_CODE_LABEL } from '@/Constants'

const Weather = {}

Weather.getWeatherAndPlace = async (coords) => {
    if (coords?.latitude == null || coords?.longitude == null) return null

    try {
        const [weatherData, placeData] = await Promise.all([
            fetch(`https://api.open-meteo.com/v1/forecast?latitude=${coords.latitude}&longitude=${coords.longitude}&current_weather=true`).then(r => r.json()),
            fetch(`https://nominatim.openstreetmap.org/reverse?lat=${coords.latitude}&lon=${coords.longitude}&format=json`, {
                headers: { 'User-Agent': 'SoccerHowApp/1.0' }
            }).then(r => r.json())
        ])

        const current = weatherData?.current_weather || {}
        const addr = placeData?.address || {}
        const placeName = addr.city || addr.town || addr.county || addr.state || addr.region || addr.municipality || addr.country || '현재 위치'
        const weathercode = current.weathercode
        const weathercode_label = WEATHER_CODE_LABEL[weathercode] ?? '알 수 없음'

        return {
            placeName,
            temperature: current.temperature ?? 0,
            weathercode: weathercode ?? 0,
            weathercode_label
        }
    } catch (err) {
        console.error('Weather.getWeatherAndPlace 에러', err)
        return null
    }
}

window.Weather = Weather
export default Weather